import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  redirectUrl: null,
  shouldRedirect: false
};

export const sliceName = 'redirect'
export const redirectSlice = createSlice({
  name: sliceName,
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload
      state.shouldRedirect = true
    },
    resetShouldRedirect: (state, action) => {
      state.shouldRedirect = false
    }
  }
});

export const selectRedirectUrl = (state) => state[sliceName]?.redirectUrl;
export const selectShouldRedirect = (state) => state[sliceName]?.shouldRedirect;

export const { setRedirectUrl, resetShouldRedirect } = redirectSlice.actions;

export default redirectSlice.reducer;
